import RootContainer from './RootContainer'

export default {
  path: '/',
  exact: true,
  Component: RootContainer,
  access: 'PUBLIC',
}
